/* eslint-disable import/prefer-default-export */
import { useEffect } from 'react';
import { nanoid } from 'nanoid';
import { useQueryState } from 'nuqs';
import { queryStateParser, queryParam, backwardsCompatabilityFactory, QueryStateSchema } from './queryStateParser';

const QS_KEY = 'previewDocumentId';
const QS_TYPE: QueryStateSchema['type'] = 'previewDocument';

export const useOpenPreviewDocumentPane = (): ((args: { previewDocumentId: string }) => void) => {
  const [previewDocumentIdDeprecated, setPreviewDocumentId] = useQueryState(QS_KEY, { history: 'push' });
  const [__, setState] = useQueryState(queryParam, queryStateParser);

  useEffect(() => {
    if (previewDocumentIdDeprecated) {
      setPreviewDocumentId(null);
      setState(backwardsCompatabilityFactory({ id: previewDocumentIdDeprecated, type: QS_TYPE }));
    }
  }, [previewDocumentIdDeprecated]);

  return ({ previewDocumentId }) => {
    setState(prevState => [...(prevState || []), {
      id: previewDocumentId,
      key: nanoid(),
      type: QS_TYPE,
    }]);
  };
};
